import { useEffect, useRef, useState } from "react";

// Track or playlist both work, e.g. spotify:playlist:37i9dQZF1DXcBWIGoYBM5M
const SPOTIFY_URI = "spotify:track:2HDdFE3LzgZ2ZWVXS0jEQF";

function loadSpotifyIframeApi() {
  if (window.__spotifyIframeApi) {
    return Promise.resolve(window.__spotifyIframeApi);
  }

  return new Promise((resolve) => {
    const prev = window.onSpotifyIframeApiReady;
    window.onSpotifyIframeApiReady = (api) => {
      window.__spotifyIframeApi = api;
      if (typeof prev === "function") prev(api);
      resolve(api);
    };

    if (!document.querySelector('script[src*="open.spotify.com/embed/iframe-api"]')) {
      const script = document.createElement("script");
      script.src = "https://open.spotify.com/embed/iframe-api/v1";
      script.async = true;
      document.body.appendChild(script);
    }
  });
}

export default function SpotifyDock() {
  const hostRef = useRef(null);
  const controllerRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return undefined;

    let cancelled = false;

    loadSpotifyIframeApi().then((api) => {
      if (cancelled || !hostRef.current) return;
      api.createController(
        host,
        {
          uri: SPOTIFY_URI,
          width: "100%",
          height: "80",
          theme: "dark",
        },
        (controller) => {
          if (cancelled) {
            controller.destroy?.();
            return;
          }
          controllerRef.current = controller;
          controller.addListener("playback_update", (event) => {
            setPlaying(!event.data.isPaused);
          });
        },
      );
    });

    return () => {
      cancelled = true;
      controllerRef.current?.destroy?.();
      controllerRef.current = null;
    };
  }, []);

  const toggle = () => {
    controllerRef.current?.togglePlay();
  };

  return (
    <div className="spotify-dock">
      <button type="button" className="spotify-play" onClick={toggle}>
        <span className="titleFont">{playing ? "PAUSE" : "PLAY"}</span>
        <span>{playing ? "On air" : "Tune in"}</span>
      </button>
      <div ref={hostRef} className="spotify-embed" />
    </div>
  );
}
